import { render } from "./BackButton.vue?vue&type=template&id=b2d7b8a2&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=b2d7b8a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d7b8a2"],['__file',"src/assets/js/components/BackButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2d7b8a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2d7b8a2', __exports__)) {
    api.reload('b2d7b8a2', __exports__)
  }
  
  module.hot.accept("./BackButton.vue?vue&type=template&id=b2d7b8a2&scoped=true", () => {
    api.rerender('b2d7b8a2', render)
  })

}


export default __exports__